import { JiraIcon } from "#components/ui/JiraIcon.tsx";
import { IconAssets } from "#types/assets.ts";
import type { IntegrationManifest } from "./types.ts";

export const jiraManifest: IntegrationManifest = {
    key: "jira",
    displayName: "Jira",
    nameKey: "channels.jira",
    descriptionKey: "jiraDescription",
    trayDescriptionKey: "composerTrayDescriptions.jira",
    cardDescriptionKey: "connectIntegration.descriptions.jira",
    connectedContentKeys: ["jiraWorkItems", "jiraProjects"],
    brandColor: "#1868DB",
    iconUrl: IconAssets.Jira,
    iconUrlAlt: IconAssets.JiraAlt,
    glyph: JiraIcon,
    channelType: "UserJira",
    dataSources: ["jira_issue"]
};
